import React from 'react'

import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'bootstrap/dist/css/bootstrap.css'
import './tokens.css'
import App from './App'
import {createRoot} from "react-dom/client";

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);